function GenericError(message) {
  this.name = 'GenericError'
  this.message = 'Generic Error - ' + message || 'Something happen that was unexpected'
  // Use V8's native method if available, otherwise fallback
  if ('captureStackTrace' in Error) { Error.captureStackTrace(this, GenericError) }
  else { this.stack = (new Error()).stack }
}
GenericError.prototype = Object.create(Error.prototype)
GenericError.prototype.constructor = GenericError

function PaymentError(message) {
  this.name = 'PaymentError'
  this.message = 'Payment Error - ' + message || 'An error was encountered processing the payment'
  // Use V8's native method if available, otherwise fallback
  if ('captureStackTrace' in Error) { Error.captureStackTrace(this, PaymentError) }
  else { this.stack = (new Error()).stack }
}
PaymentError.prototype = Object.create(Error.prototype)
PaymentError.prototype.constructor = PaymentError

function ProcessingError(message) {
  this.name = 'PaymentError'
  this.message = 'Processing Error - ' + message || 'An error was encountered during internal processing'
  // Use V8's native method if available, otherwise fallback
  if ('captureStackTrace' in Error) { Error.captureStackTrace(this, ProcessingError) }
  else { this.stack = (new Error()).stack }
}
ProcessingError.prototype = Object.create(Error.prototype)
ProcessingError.prototype.constructor = ProcessingError

function APIError(message) {
  this.name = 'APIError'
  this.message = 'API Error - ' + message || 'An error was encountered call and internal API function'
  // Use V8's native method if available, otherwise fallback
  if ('captureStackTrace' in Error) { Error.captureStackTrace(this, APIError) }
  else { this.stack = (new Error()).stack }
}
APIError.prototype = Object.create(Error.prototype)
APIError.prototype.constructor = APIError

function TransactionError(message, details) {
  this.name = 'TransactionError'
  this.message = 'Transaction Error - ' + message || 'Transaction Error - Something went wrong retrieving the transaction.'
  this.details = details
  // Use V8's native method if available, otherwise fallback
  if ('captureStackTrace' in Error) { Error.captureStackTrace(this, TransactionError) }
  else { this.stack = (new Error()).stack }
}
TransactionError.prototype = Object.create(Error.prototype)
TransactionError.prototype.constructor = TransactionError

function TransactionStatusError(message, details) {
  this.name = 'TransactionStatusError'
  this.message = message || 'Transaction Status Error - transaction status is invalid for payment.'
  this.details = details
  // Use V8's native method if available, otherwise fallback
  if ('captureStackTrace' in Error) { Error.captureStackTrace(this, TransactionError) }
  else { this.stack = (new Error()).stack }
}
TransactionStatusError.prototype = Object.create(Error.prototype)
TransactionStatusError.prototype.constructor = TransactionStatusError

function StoreCardError(message, details) {
  this.name = 'StoreCardError'
  this.message = 'Store Card Error - ' + message || 'An error was encountered during storing the credit card details'
  this.details = details
  // Use V8's native method if available, otherwise fallback
  if ('captureStackTrace' in Error) { Error.captureStackTrace(this, StoreCardError) }
  else { this.stack = (new Error()).stack }
}
StoreCardError.prototype = Object.create(Error.prototype)
StoreCardError.prototype.constructor = StoreCardError

function RateLimitExceededError(message) {
  this.name = 'RateLimitExceededError'
  this.message = 'Rate Limit Exceeded - ' + message || 'The system has detected that you are making too many payment request in too short a period of time.'
  // Use V8's native method if available, otherwise fallback
  if ('captureStackTrace' in Error) { Error.captureStackTrace(this, RateLimitExceededError) }
  else { this.stack = (new Error()).stack }
}
RateLimitExceededError.prototype = Object.create(Error.prototype)
RateLimitExceededError.prototype.constructor = RateLimitExceededError

export {
  GenericError,
  PaymentError,
  ProcessingError,
  APIError,
  TransactionError,
  TransactionStatusError,
  StoreCardError,
  RateLimitExceededError
}
